(function () {
  var SAR_RATE = 3.75;
  var CURRENCY = 'SAR';

  function toNumber(cents) {
    var value = Number(cents || 0);
    return Number.isFinite(value) ? value : 0;
  }

  function isArabic() {
    return String(document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  }

  function formatCents(cents) {
    var amount = Math.round(toNumber(cents) * SAR_RATE) / 100;
    var formatted = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return isArabic() ? formatted + ' ر.س' : CURRENCY + ' ' + formatted;
  }

  function parseUsdText(text) {
    if (!text || /SAR/i.test(text)) return null;
    var match = String(text).match(/\$\s*([0-9][0-9,]*(?:\.[0-9]{1,2})?)|([0-9][0-9,]*(?:\.[0-9]{1,2})?)\s*USD/i);
    if (!match) return null;
    var raw = (match[1] || match[2] || '').replace(/,/g, '');
    var value = Number(raw);
    if (!Number.isFinite(value)) return null;
    return Math.round(value * 100);
  }

  function convertPriceNode(node) {
    if (!node || node.children.length) return;
    var cents = parseUsdText(node.textContent);
    if (cents === null) return;
    node.textContent = formatCents(cents);
    node.dataset.nawaSarConverted = 'true';
  }

  function convertExistingPrices(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selector = [
      '.price-item',
      '.money',
      '.bvc-product-price',
      '.bvc-product-compare',
      '.bvc-cart-price',
      '.bvc-cart-sticky strong',
      '[data-bvc-current-price]',
      '[data-bvc-cart-subtotal]',
      '[data-bvc-original-total]',
      '[data-item-original-price-display]',
      '[data-item-final-price-display]',
      '[data-item-price-with-quantity-display]',
      '[data-cart-total-value] .text',
      '.cart-total-value > .text',
      '.cart-item-value',
      '[data-nawa-desktop-price]',
      '[data-nawa-desktop-compare]',
      '.nawa-desktop-home__price',
      '.nawa-video-price-row strong',
      '.nawa-video-overlay-product strong',
      '.dubai-cart-rec-info span'
    ].join(',');
    scope.querySelectorAll(selector).forEach(convertPriceNode);
  }

  window.NAWASARPricing = {
    currency: CURRENCY,
    rate: SAR_RATE,
    formatCents: formatCents,
    convertExistingPrices: convertExistingPrices
  };

  document.documentElement.setAttribute('data-nawa-display-currency', CURRENCY);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      convertExistingPrices(document);
    });
  } else {
    convertExistingPrices(document);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) convertExistingPrices(node);
        });
        if (mutation.type === 'characterData' && mutation.target && mutation.target.parentElement) {
          convertPriceNode(mutation.target.parentElement);
        }
      });
    }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  }
})();
